<template>
  <div class="card">
    <div class="card-content">
      <div class="level">
        <div class="level-left">
          <article class="media">
            <figure class="media-left">
              <p class="image is-128x128">
                <img :src="reseau.urlPhoto">
              </p>
            </figure>
            <div class="media-content">
              <div class="content">
                <h3 class="has-text-weight-bold ellipsis colonneRechercheOpportuniteThemeCampagne">
                  Réseau : <span>{{reseau.libelle}}</span>
                </h3>
                <p class="is-size-14px">
                  Nb de faces: {{reseau.listeFaces.length}} <br>
                  {{periode}}
                </p>
              </div>
            </div>
          </article>
        </div>
        <div class="level-right class-left">
          <div class="content">
            <h3 class="has-text-weight-bold has-text-default">
              {{reseau.listeFaces.filter((el) => el.selected).length}} sur
              {{reseau.listeFaces.length}} faces sélectionnées
            </h3>
          </div>
        </div>
      </div>
      <div>
        <b-table
          :data="copyReseaux"
          :columns="columns"
          bordered
          striped
          :checked-rows.sync="checkedRows"
          checkable>
        </b-table>
      </div>
      <div class="level pt-40">
        <div class="level-left">
          <div class="buttons">
            <b-button
              @click="$emit('close')">
              Annuler
            </b-button>
            <b-button
              @click="dupliquer()"
              type="is-primary">
              Dupliquer
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/panier-mutation-type';
import { getDateByJourAnneeSemaine } from '@/services/general/getAnneeSemaine';

const Panier = createNamespacedHelpers('panier');

export default {
  name: 'liste-copy-faces-reseau',
  props: ['reseau', 'disabled'],
  data() {
    return {
      checkedRows: [],
      copyReseaux: [],
      columns: [
        {
          field: 'semaine',
          label: 'Semaine',
          headerClass: 'has-text-default has-text-weight-bold',
          cellClass: 'has-text-default',
          sortable: true,
        },
        {
          field: 'nbFacesReseau',
          label: 'Nb de faces réseau',
          headerClass: 'has-text-default has-text-weight-bold',
          cellClass: 'has-text-default',
          sortable: true,
        },
        {
          field: 'nbFacesVendues',
          label: 'Nb de faces vendues',
          headerClass: 'has-text-default has-text-weight-bold',
          cellClass: 'has-text-default',
          sortable: true,
        },
        {
          field: 'nbFacesSelect',
          label: 'Nb de faces sélectionnées',
          headerClass: 'has-text-default has-text-weight-bold',
          cellClass: 'has-text-default',
          sortable: true,
        },
      ],
    };
  },
  computed: {
    ...Panier.mapGetters({
      reseauxTempoPanier: 'reseauxTempoPanier',
    }),
    periode() {
      const dateDebut = getDateByJourAnneeSemaine(
        this.reseau.jourDepart,
        this.reseau.extensionOpportunite.annee,
        this.reseau.extensionOpportunite.semaine,
      );
      return `S${this.reseau.extensionOpportunite.semaine}
        du ${dateDebut.format('DD MMM')}
        au ${dateDebut.clone().add(7 * this.reseau.dureeConservation, 'days').add(-1, 'days').format('DD MMMM YYYY')}`;
    },
  },
  methods: {
    ...Panier.mapMutations({
      setReseauxTempoPanier: types.SET_PRODUIT_TYPE_RESEAU_TEMPO,
    }),
    dupliquer() {
      if (this.checkedRows.length) {
        this.checkedRows.forEach(reseau => {
          this.setReseauxTempoPanier({
            semaine: reseau.sem,
            annee: reseau.annee,
            num: reseau.num,
            faces: this.reseau.listeFaces,
          });
        });
      }
      this.$emit('close');
    },
  },
  mounted() {
    this.copyReseaux = this.reseauxTempoPanier
      .filter(reseau => reseau.num === this.reseau.num
        && !(reseau.extensionOpportunite.semaine === this.reseau.extensionOpportunite.semaine
        && reseau.extensionOpportunite.annee === this.reseau.extensionOpportunite.annee))
      .map(reseau => {
        const dateDebut = getDateByJourAnneeSemaine(
          reseau.jourDepart,
          reseau.extensionOpportunite.annee,
          reseau.extensionOpportunite.semaine,
        );
        const semaine = `S${reseau.extensionOpportunite.semaine}
          du ${dateDebut.format('DD MMM')}
          au ${dateDebut.clone().add(7 * reseau.dureeConservation, 'days').add(-1, 'days').format('DD MMM YYYY')}`;
        return {
          num: reseau.num,
          annee: reseau.extensionOpportunite.annee,
          sem: reseau.extensionOpportunite.semaine,
          semaine,
          nbFacesReseau: reseau.listeFaces.length,
          nbFacesVendues: reseau.nbrFacesRestantes
            ? reseau.listeFaces.length - reseau.nbrFacesRestantes : 0,
          nbFacesSelect: reseau.listeFaces.filter((el) => el.selected).length,
        };
      });
  },
};
</script>

<style scoped>
.class-left {
  align-items: baseline;
  height: 128px;
}
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/composantsProduits/venteReseauxTempo/copyFaceReseau.vue